<div class="text-center">
  <h1>{{ "set-pin.title" | i18next }}</h1>
  <p>{{ "set-pin.description" | i18next }}</p>
  <code-input
    class="margin-b-1"
    [isCodeHidden]="true"
    (codeCompleted)="setPinCompleted($event)"
  >
  </code-input>
</div>
